import React from 'react';
import cn from 'classnames';

import loader from 'assets/images/login/loader.svg';
import styles from './styles.scss';

export const Button = ({
  onClick = () => {},
  isLoading = false,
  isDisabled = false,
  isPrimary = false,
  children
}) => {
  const handleClick = () => {
    if (isLoading) {
      return;
    }

    if (isDisabled) {
      return;
    }

    onClick && onClick();
  };

  return (
    <div
      className={cn(styles.Button, {
        [styles.ButtonPrimary]: isPrimary,
        [styles.ButtonStateDisabled]: isDisabled,
        [styles.ButtonSecondary]: !isPrimary
      })}
      onClick={handleClick}
    >
      {isLoading
        ? (
          <React.Fragment>
            <img className={styles.Loader} src={loader} />
            <span />
          </React.Fragment>
        )
        : children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Login/Button/index.js